import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useClickAway } from "react-use";
import { createPortal } from "react-dom";

const AnimatedDialogLayout = ({
  children,
  isOpen,
  onClose,
  styleDropdown,
  backdropStyle,
}) => {
  const ref = React.useRef(null);

  useEffect(() => {
    // Create the modal-root element if it doesn't exist
    if (!document.getElementById("modal-root")) {
      const modalRoot = document.createElement("div");
      modalRoot.id = "modal-root";
      document.body.appendChild(modalRoot);
    }
  }, []);

  // Modified to check if the click is within any dropdown that's portaled to the body
  useClickAway(ref, (e) => {
    // Don't close if clicking on a dropdown that's portaled to the body
    const isClickOnPortaledDropdown =
      e.target.closest(".filter-dropdown-shadow") !== null;
    if (isOpen && !isClickOnPortaledDropdown) {
      onClose();
    }
  });

  if (!isOpen) return null;

  // Get or create the modal root element
  const modalRoot = document.getElementById("modal-root") || document.body;

  // Create the dialog content
  const dialogContent = (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999] !m-0 flex items-center justify-center bg-black bg-opacity-50"
      style={backdropStyle}
      onClick={(e) => {
        // Don't close if clicking on a dropdown
        const isClickOnDropdown =
          e.target.closest(".filter-dropdown-shadow") !== null;
        if (!isClickOnDropdown) {
          e.stopPropagation();
        }
      }}
    >
      <motion.div
        ref={ref}
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.8, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="bg-white max-h-[80%] overflow-y-auto z-[9999] w-full xs:w-auto xs:min-w-[369px] rounded-[14px] p-[14px] pt-[11px] shadow-lg mx-4"
        style={styleDropdown}
      >
        {children}
      </motion.div>
    </motion.div>
  );

  // Use createPortal to render to the modal-root div
  return createPortal(dialogContent, modalRoot);
};

export default AnimatedDialogLayout;
